import React from 'react';


class Accordion extends React.Component {
    render () {
        return (
            <div className="accordion">
                {this.props.children}
            </div>
        );
    }
}

export default Accordion;


/** WEBPACK FOOTER **
 ** ./src/components/Accordion/index.js
 **/